module.exports = __webpack_public_path__ + "static/media/298268.dbea9308.png";